const saveItem = (key: string, value: unknown) => {
    sessionStorage.setItem(key, JSON.stringify(value));
};

const getItem = (key: string) => {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
};

const removeItem = (key: string) => {
    sessionStorage.removeItem(key);
};

export {
    saveItem,
    getItem,
    removeItem,
};
